import { Button, ButtonColor, useHasAccess } from "@quortex/front-common"
import { isEmpty } from "lodash-es"
import type { FC } from "react"
import AddOttEndpointButton from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/AddOttEndpointButton"
import OttEndpointTable from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/OttEndpointTable"
import type { OttEndpointRow } from "@/App/play/App/Main/Pool/endpoints/ottEndpoints/OttEndpointList/types"
import OttEndpointWizardEmptyState from "@/App/play/components/features/endpoints/ottEndpoints/OttEndpointWizardStep/OttEndpointWizardEmptyState"
import { usePoolPath } from "@/App/play/hooks/navigation"

type Props = {
  row?: OttEndpointRow
}

const OttEndpointWizardStep: FC<Props> = ({ row }) => {
  const hasEndpoints = !isEmpty(row?.endpoints)
  const hasWriteAccess = useHasAccess(["owner", "editor"])
  const poolPath = usePoolPath()

  return (
    <>
      {hasEndpoints ? (
        <div className="radius-sm w-full border border-grey-300 bg-grey-100 p-md">
          <div className="overflow-x-auto">
            <OttEndpointTable
              endpoints={row?.endpoints || []}
              prettySearchRegExps={[]}
              searchRegExps={[]}
            />
          </div>
          {hasWriteAccess && !!row && (
            <div className="mt-sm flex items-center justify-end">
              <AddOttEndpointButton row={row} />
            </div>
          )}
        </div>
      ) : (
        <OttEndpointWizardEmptyState hasWriteAccess={hasWriteAccess} row={row} />
      )}
      <div className="mt-lg space-x-sm">
        <Button color={ButtonColor.SECONDARY} to={poolPath} type="link">
          Cancel
        </Button>
        <Button color={ButtonColor.PRIMARY} to="../done" type="link">
          Save
        </Button>
      </div>
    </>
  )
}

export default OttEndpointWizardStep
